import { Injectable } from '@angular/core';
import { FiBackendService } from '../../fi-backend/fi-backend.service';
import { IItemsListDataFetchResult } from '@fi-shared/fi-items-list/fi-items-list';
import { IChecklist2Parameter, IChecklistV2, IChecklistV2ForList } from '@fi-shared/checklist/checklist-v2';
import { AccessRightType, ApplicationSettingsType } from '@fi-shared/types';
import { AccessToApplicationTypeService } from '@fi-shared/fi-shared-services/access-to-application-type.service';

@Injectable()
export class FiChecklist2AuditService {
    constructor(
        private fiBackend: FiBackendService,
        private accessToApplicationTypeService: AccessToApplicationTypeService,
    ) {}

    isChecklistAuditShareRights() {
        return this.accessToApplicationTypeService.HasAccessToApplicationType(
            ApplicationSettingsType.ChecklistV2AuditLocal,
            AccessRightType.Share,
        );
    }

    getChecklistAuditListData(parameter: IChecklist2Parameter) {
        const promise = this.fiBackend.fetchDataPost<IItemsListDataFetchResult<IChecklistV2ForList>>(
            'Checklist/Checklist2Audit/GetChecklistAuditListData',
            parameter,
        );
        return promise;
    }
}
